<div class="globe-overlay" role="alertdialog" aria-live="polite" [attr.aria-label]="title">
  <div class="globe-stage">
    <svg class="globe" viewBox="0 0 400 400" aria-hidden="true">
      <defs>
        <clipPath id="gFace"><circle cx="200" cy="200" r="50" /></clipPath>

        <!-- Soft-UI plate: one dark shadow down-right, one white highlight up-left. -->
        <filter id="gPlate" x="-60%" y="-60%" width="220%" height="220%">
          <feDropShadow dx="7" dy="9" stdDeviation="9" flood-color="#a9a9bb" flood-opacity="0.55" />
          <feDropShadow dx="-6" dy="-7" stdDeviation="8" flood-color="#ffffff" flood-opacity="0.95" />
        </filter>
      </defs>

      <rect class="guide" x="76" y="76" width="248" height="248" rx="62" />
      <circle class="plate" cx="200" cy="200" r="78" filter="url(#gPlate)" />

      <g class="planet">
        <g clip-path="url(#gFace)">
          <!-- Latitudes are unaffected by a spin about the vertical axis, so they stay put. -->
          <ellipse class="lat" cx="200" cy="200" rx="50" ry="11" />
          <ellipse class="lat" cx="200" cy="176" rx="44" ry="9" />
          <ellipse class="lat" cx="200" cy="224" rx="44" ry="9" />

          <!-- Meridians turn by scaleX: a full sweep from face-on to edge-on and back is half a
               revolution, so they run at half the globe's period, evenly phased. -->
          <ellipse class="mer" style="--d: 0s" cx="200" cy="200" rx="50" ry="50" />
          <ellipse class="mer" style="--d: -0.275s" cx="200" cy="200" rx="50" ry="50" />
          <ellipse class="mer" style="--d: -0.55s" cx="200" cy="200" rx="50" ry="50" />
          <ellipse class="mer" style="--d: -0.825s" cx="200" cy="200" rx="50" ry="50" />

          <!-- Surface features. Each is drawn in its face-on pose and carried around the sphere by
               one shared keyframe set; --r is the radius of its latitude circle and --d is its
               longitude, expressed as a negative delay. -->
          <g class="feat" style="--r: 47px; --d: 0s">
            <path d="M 185.4,175.6 C 197.6,167.1 213.4,173.2 212.2,186.6 C 211.0,198.8 196.3,201.2 190.2,209.8 C 182.9,218.3 173.2,209.8 174.4,196.3 C 175.6,184.1 178.0,180.5 185.4,175.6 Z" />
          </g>

          <g class="feat" style="--r: 44px; --d: -0.45s">
            <path d="M 193.9,217.1 C 204.9,211.0 217.1,217.1 215.9,226.8 C 214.6,236.6 200.0,239.0 193.9,232.9 C 187.8,226.8 186.6,220.7 193.9,217.1 Z" />
          </g>

          <g class="feat" style="--r: 40px; --d: -0.95s">
            <path d="M 190.2,165.8 C 198.8,159.7 209.8,163.4 211.0,170.7 C 212.2,178.0 202.4,181.7 196.3,178.0 C 190.2,174.4 185.4,169.5 190.2,165.8 Z" />
          </g>

          <g class="feat" style="--r: 43px; --d: -1.35s">
            <path d="M 195.1,206.1 C 203.7,201.2 213.4,206.1 212.2,213.4 C 211.0,220.7 200.0,222.0 195.1,217.1 Z" />
            <circle cx="215.9" cy="190.2" r="4.1" />
          </g>

          <!-- the country being reached, riding round with the surface -->
          <g class="feat feat--pin" style="--r: 45px; --d: -1.7s">
            <path d="M 200.0,163.4 C 206.1,163.4 211.0,168.3 211.0,174.4 C 211.0,182.9 200.0,193.9 200.0,193.9 C 200.0,193.9 189.0,182.9 189.0,174.4 C 189.0,168.3 193.9,163.4 200.0,163.4 Z" />
            <circle class="feat__pip" cx="200.0" cy="174.4" r="3.3" />
          </g>
        </g>

        <circle class="edge" cx="200" cy="200" r="50" />
      </g>
    </svg>
  </div>

  <div class="globe-copy">
    <h2 class="globe-title">{{ title }}</h2>

    @if (caption) {
      <p class="globe-caption" [attr.data-step]="stepIndex()">{{ caption }}</p>
    }

    @if (steps.length > 1) {
      <div class="globe-dots" aria-hidden="true">
        @for (s of steps; track $index) {
          <span class="globe-dots__dot" [class.globe-dots__dot--done]="$index <= stepIndex()"></span>
        }
      </div>
    }

    <div class="globe-track" aria-hidden="true"><span class="globe-track__bar"></span></div>

    <p class="globe-hint">This writes to the chain and can take a few seconds. Please don't close this page.</p>
  </div>
</div>
